<template>
  <div class="py-2">
    <section>
      <div>
        <h1>{{$t('tuka.site.name')}}</h1>
      </div>
    </section>
    <section class="row">
      <div v-for="card in sidebarContent" class="col col-md-4" :key="card.name">
        <router-link
          class="componentpage-link"
          :to="{ 
            name: 'componentpage', 
            params: { 
              componentPage: urlFormatted(card.name)
            } 
          }"
        >
          <img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" height="200px" />
          <h3>{{ card.name }}</h3>
          <p>{{ card.description }}</p>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import * as http from "../http";
import { mapGetters } from "vuex";

import { createUrlString } from "../store/helpers";

export default {
  name: "Frontpage",
  data() {
    return {
      cards: [
        {
          name: "Katsaus",
          description:
            "Testisisältöä sisältävä katsaus nro 1.",
          img: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
        }
      ],
    };
  },
  computed: {
    ...mapGetters(["sidebarContent"]),
  },
  methods: {
    showHeaderFooter() {
      // document.getElementById("banner").style.removeProperty("display");
      // document.getElementById("footer").style.removeProperty("display");
    },
    urlFormatted(name) {
      // TODO: HTML-compliant url:s
      return createUrlString(name);
    }
  },
};
</script>

<style lang="scss" scoped>
/*
.componentpage-link {
  text-decoration: none;
}
*/
</style>
